// extracted by mini-css-extract-plugin
export var outer = "Question-module--outer--2RuCt";
export var questionSubtitle = "Question-module--question-subtitle--1REZE";
export var questionTitle = "Question-module--question-title--21jAT";
export var answersWrapper = "Question-module--answers-wrapper--3CR8f";
export var answersList = "Question-module--answers-list--3pB0u";